import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
var styles = require('./../MailListHeader.scss');
var classNames = require('classnames/bind').bind(styles);
var MailListActionHeaderThirdRow = /** @class */ (function (_super) {
    tslib_1.__extends(MailListActionHeaderThirdRow, _super);
    function MailListActionHeaderThirdRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (evt) {
            _this.props.onClick(evt, _this.props.distinguishedFolderId);
        };
        _this.renderLink = function () {
            return (React.createElement(Link, { onClick: _this.handleClick, className: styles.actionHeaderThirdRow, title: _this.props.text },
                _this.props.showBackArrow && (React.createElement(Icon, { iconName: "ChevronLeft" /* ChevronLeft */, className: classNames(styles.linkIcon, 'flipForRtl') })),
                React.createElement("span", { className: styles.actionHeaderThirdRowText }, _this.props.text),
                _this.props.showLoadingSpinner && (React.createElement(Spinner, { className: styles.spinner, size: SpinnerSize.small }))));
        };
        _this.renderPlainText = function () {
            return React.createElement("span", { className: styles.actionHeaderThirdRowText }, _this.props.text);
        };
        return _this;
    }
    MailListActionHeaderThirdRow.prototype.render = function () {
        return (React.createElement("div", { className: this.props.containerCssClass }, this.props.onClick ? this.renderLink() : this.renderPlainText()));
    };
    MailListActionHeaderThirdRow = tslib_1.__decorate([
        observer
    ], MailListActionHeaderThirdRow);
    return MailListActionHeaderThirdRow;
}(React.Component));
export default MailListActionHeaderThirdRow;
//# sourceMappingURL=MailListActionHeaderThirdRow.js.map